import * as React from 'react';
import { Button, makeStyles, mergeClasses, shorthands, Spinner, tokens } from '@fluentui/react-components';
import type { EmailVerification } from '@foundershub/api-client';
import { useEmailVerifyMutation } from '@foundershub/api-client';

interface Props {
  verification: EmailVerification;
  setShowError: (value: boolean) => void;
  transparent?: boolean;
  buttonClass?: string;
}

export function ResendButton({ verification, setShowError, transparent, buttonClass }: Props) {
  const classes = useStyles();

  const [resendEmail, { isSuccess, isLoading, isError }] = useEmailVerifyMutation();
  const [buttonEnabled, setButtonEnabled] = React.useState(false);

  function handleClick() {
    resendEmail({ email: verification.email });
  }

  React.useEffect(() => {
    if (isSuccess) {
      setButtonEnabled(false);
    }
    setShowError(isError);
  }, [isSuccess, isError]);

  React.useEffect(() => {
    const timer = setTimeout(
      () => {
        setButtonEnabled(true);
      },
      1000 * 60 * 10 // 10 minutes
    );
    return () => clearTimeout(timer);
  }, [buttonEnabled]);

  return (
    <div>
      <Button
        appearance={transparent ? 'transparent' : 'primary'}
        disabled={!buttonEnabled || isLoading}
        onClick={handleClick}
        className={mergeClasses(buttonClass, transparent && classes.transparent, classes.button)}
      >
        {isLoading && <Spinner size="extra-tiny" className={classes.spinner} />}
        Resend
      </Button>
    </div>
  );
}

const useStyles = makeStyles({
  button: {
    minWidth: '0',
  },
  transparent: {
    paddingLeft: tokens.spacingHorizontalNone,
  },
  spinner: {
    ...shorthands.margin(0, tokens.spacingHorizontalS, 0, 0),
  },
});
